import { Col, Row, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  puntoventaLogout,
  puntoventaSetCurrentStep,
} from "../../../actions/venta";
import { useNavigate } from "react-router-dom";
import {
  BackNavBtn,
  CloseBtn,
  ExitBtn,
  NewBtn,
  NextNavBtn,
  SaveBtn,
} from "../../ui";

export const ButtonsChangeSteps = ({ stepsLength }) => {
  const { currentStep } = useSelector((state) => state.venta);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const prev = () => {
    dispatch(
      puntoventaSetCurrentStep({
        ...currentStep,
        current: currentStep?.current - 1,
      }),
    );
  };

  const handleCancel = () => {
    dispatch(puntoventaSetCurrentStep({ ...currentStep, current: 0 }));
    dispatch(puntoventaLogout());
  };
  const handleExit = () => {
    dispatch(puntoventaLogout());
    navigate("/");
  };

  return (
    <Row>
      <Col span={24}>
        <Space wrap>
          {currentStep?.current > 0 &&
            currentStep?.current < stepsLength - 1 && (
              <BackNavBtn onClick={prev} />
            )}
          {currentStep?.current < stepsLength - 2 && (
            <NextNavBtn htmlType="submit" />
          )}
          {currentStep?.current === stepsLength - 2 && (
            <SaveBtn htmlType="submit" />
          )}
          {currentStep?.current === stepsLength - 1 && (
            <>
              <Space wrap>
                <ExitBtn onClick={handleExit} />
                <NewBtn text="Nueva venta" onClick={handleCancel} />
              </Space>
            </>
          )}
          {currentStep?.current > 0 &&
            currentStep?.current < stepsLength - 1 && (
              <CloseBtn onClick={handleCancel} />
            )}
          {
            currentStep?.current === 0 && (
              <ExitBtn onClick={handleExit} />
            ) /* Mostrar el botón "Cerrar" solo en el primer paso */
          }
        </Space>
      </Col>
    </Row>
  );
};
